type OnChange<T> = (value: T, key: keyof T, action?: "tag-dismissed") => void

export const createTagDismissHandler = <T extends Record<string, unknown>>(value: T, onChange: OnChange<T>) => {
	return (key: keyof T) => (_val: string, index: number) => {
		const currentValue = value[key]
		const newValue = Array.isArray(currentValue) ? currentValue.filter((_item, i) => index !== i) : ""
		onChange({ ...value, [key]: newValue }, key, "tag-dismissed")
	}
}
